module.exports = __webpack_public_path__ + "static/img/新闻二@2xs.4c920f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/新闻二@2xs.png
// module id = zwCi
// module chunks = 0